import { render, staticRenderFns } from "./sh_ChooseRole.vue?vue&type=template&id=1206d672&"
import script from "./sh_ChooseRole.vue?vue&type=script&lang=js&"
export * from "./sh_ChooseRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports